import React from 'react'

const Accessories = () => {
  return (
    <div>
          <h1>clothing</h1>
      
    </div>
  )
}

export default Accessories
